<template>
    <v-row>
        <v-col cols="12" sm="6" md="6" align-self="center">
            <v-text-field
                v-model="autoImportConfig.rootFolder"
                :label="$t('RootFolder')"
                :error-messages="folderErrors()"
            />
        </v-col>
        <v-col cols="auto" align-self="center">
        <v-tooltip top>
            <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="checkFolder(autoImportConfig)"
            >
                <v-icon dark>mdi-folder-search-outline</v-icon>
            </v-btn>
            </template>
            <span>{{ $t("Test") }}</span>
        </v-tooltip>
        </v-col>
        <v-col cols="auto" align-self="center">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    icon
                    dark
                    color="primary"
                    @click="createFolder(autoImportConfig)"
                >
                    <v-icon dark>mdi-folder-plus-outline</v-icon>
                </v-btn>
                </template>
                <span>{{ $t("CreateFolder") }}</span>
            </v-tooltip>
        </v-col>

        <ContentTypeAutoImportConfigModalCreateFolder
            :ref="folderModalKey"
            @on-saved="onFolderCreated"
        />
    </v-row>
</template>

<script>
import AutoImportService from '@/services/AutoImportService';
import Utils from '@/ecm/common/Utils';
import ContentTypeAutoImportConfigModalCreateFolder from '@/components/administration/contentType/autoImport/ContentTypeAutoImportConfigModalCreateFolder';

export default {
    name: 'FileSystemProviderConfig',
    components: {
        ContentTypeAutoImportConfigModalCreateFolder
    },
    props: {
        validator: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            folderModalKey: 'folderModalKey',
            autoImportConfig: this.item,
        };
    },
    methods: {
        folderErrors() {
            const errors = [];
            if (!this.validator.rootFolder.$dirty) return errors;
            if (!this.validator.rootFolder.required) {
                errors.push(this.$t('RequiredField'));
            }
            return errors;
        },
        checkFolder(item) {
            var folder = {
                FolderPath: item.rootFolder,
            };
            AutoImportService.checkFolder(folder).then((result) => {
                if (result) {
                    Utils.toast.success(this.$t('CorrectFolderPath'));
                } else {
                    Utils.toast.error();
                    this.$t('IncorrectFolderPath');
                }
            });
        },
        createFolder(item) {
            this.$refs[this.folderModalKey].show(item.oAuthRefreshToken);
        },
        onFolderCreated() {
            Utils.toast.success(this.$t('SavedSuccessfully'));
        },
    }
};
</script>